var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckMarkV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "#F3F3F4",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.25 0C3.69375 0 0 3.69375 0 8.25C0 12.8062 3.69375 16.5 8.25 16.5C12.8062 16.5 16.5 12.8062 16.5 8.25C16.5 3.69375 12.8062 0 8.25 0ZM11.826 6.855C11.8918 6.77973 11.942 6.69205 11.9734 6.59713C12.0049 6.5022 12.0171 6.40194 12.0092 6.30224C12.0013 6.20254 11.9736 6.10542 11.9277 6.0166C11.8817 5.92777 11.8185 5.84903 11.7417 5.78501C11.6648 5.72098 11.576 5.67297 11.4803 5.6438C11.3847 5.61462 11.2841 5.60487 11.1847 5.61512C11.0852 5.62537 10.9888 5.65541 10.9011 5.70347C10.8134 5.75154 10.7362 5.81666 10.674 5.895L7.449 9.76425L5.78025 8.09475C5.6388 7.95813 5.44935 7.88254 5.2527 7.88424C5.05605 7.88595 4.86794 7.96483 4.72889 8.10389C4.58983 8.24294 4.51095 8.43105 4.50924 8.6277C4.50754 8.82435 4.58313 9.0138 4.71975 9.15525L6.96975 11.4053C7.04344 11.4789 7.13167 11.5364 7.22881 11.574C7.32595 11.6117 7.42987 11.6287 7.53395 11.624C7.63803 11.6193 7.73998 11.5929 7.83331 11.5466C7.92663 11.5003 8.00929 11.435 8.076 11.355L11.826 6.855Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckMarkV2);
export default __webpack_public_path__ + "static/media/check-mark-v2.e2caaf6a95b13b8cadaea63b305dac72.svg";
export { ForwardRef as ReactComponent };